function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm.191-17.969h-.382a7.778 7.778 0 00-7.778 7.778v.382a7.778 7.778 0 007.778 7.778h.382a7.778 7.778 0 007.778-7.778v-.382a7.778 7.778 0 00-7.778-7.778zm1.489 11.65a.999.999 0 01-1.414 0l-2.95-2.949a.999.999 0 01-.288-.733.998.998 0 01.288-.732l2.95-2.95a1 1 0 011.414 1.415L9.413 9.999l2.267 2.268a1 1 0 010 1.414z"
});

var SvgPrev = function SvgPrev(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTAgMjBDNC40NzcgMjAgMCAxNS41MjMgMCAxMFM0LjQ3NyAwIDEwIDBzMTAgNC40NzcgMTAgMTAtNC40NzcgMTAtMTAgMTB6bS4xOTEtMTcuOTY5aC0uMzgyYTcuNzc4IDcuNzc4IDAgMCAwLTcuNzc4IDcuNzc4di4zODJhNy43NzggNy43NzggMCAwIDAgNy43NzggNy43NzhoLjM4MmE3Ljc3OCA3Ljc3OCAwIDAgMCA3Ljc3OC03Ljc3OHYtLjM4MmE3Ljc3OCA3Ljc3OCAwIDAgMC03Ljc3OC03Ljc3OHptMS40ODkgMTEuNjVhLjk5OS45OTkgMCAwIDEtMS40MTQgMGwtMi45NS0yLjk0OWEuOTk5Ljk5OSAwIDAgMS0uMjg4LS43MzMuOTk4Ljk5OCAwIDAgMSAuMjg4LS43MzJsMi45NS0yLjk1YTEgMSAwIDAgMSAxLjQxNCAxLjQxNUw5LjQxMyA5Ljk5OWwyLjI2NyAyLjI2OGExIDEgMCAwIDEgMCAxLjQxNHoiLz4KPC9zdmc+Cg==";
export { SvgPrev as ReactComponent };